import Client from "./ApiClient";

const resource = "conversations";

const getConversations = id => {
  return Client.get(`/users/${id}/${resource}`);
};

const getMessages = (id, page = 1, perPage = 10) => {
  return Client.get(`${resource}/${id}?page=${page}&perPage=${perPage}`);
};

export default { getMessages, getConversations };
